import { transformDateValue } from 'core/js/FormUtils';
export const getStockoutproductView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let stockoutproductList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Stock Out Req Id","fieldValue":transformDataValue(data.stockoutreqid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Product Id","fieldValue":transformDataValue(data.productid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Product Name","fieldValue":transformDataValue(data.productname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Qty","fieldValue":transformDataValue(data.qty,"number"), "fieldType":"number"},
              
              
            ],
            'dataList': [
                
              ]
          }

          stockoutproductList.push(card);
  })
  return stockoutproductList;
}